const config = {
    name: 'D.Fact',
    address: 'Lavena Ponte Tresa, Italy',
    phone: '+41 (0)78 639 12 03',
    email: 'hello@dfact.agency',
    url: 'https://dfact.agency',
  };
  
  export default config;